import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import cn from 'classnames';
import css from './HeaderImageBlock.module.scss';
import { Media } from 'components/Media';
import CuriousBlock from 'components/CuriousBlock';

const HeaderImageBlock = ({
    heading,
    backgroundVideo,
    image,
    text,
    showText,
    links,
    logo,
    curious
}) => (
    <header
        className={cn(css.header, {
            [css.hasCurious]: curious && curious.text
        })}
    >
        <div className={css.image}>
            <Media
                image={image.url}
                video={backgroundVideo}
                alt={image.altText}
            />
        </div>

        <div className={css.text}>
            {/* BE: Logo recommended size is 120x120px */}
            {logo && logo.url && <img className={css.logo} src={logo.url} alt={logo.altText ? logo.altText : ''} />}
            {heading && <h1 className={css.heading}>{heading}</h1>}
            {showText && text && <p className={css.intro}>{text}</p>}

            {links && (
                <ul className={css.linksList}>
                    {links.map((link, index) => (
                        <li key={index} className={css.linksItem}>
                            <Button white {...link}>
                                {link.text}
                            </Button>
                        </li>
                    ))}
                </ul>
            )}
            {curious && curious.text && (
                <CuriousBlock {...curious} className={css.curious} />
            )}
        </div>
    </header>
);

HeaderImageBlock.propTypes = {
    logo: PropTypes.shape({
        url:PropTypes.string,
        altText: PropTypes.string
    }),
    links: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string,
            target: PropTypes.string,
            text: PropTypes.string
        })
    ),
    heading: PropTypes.string,
    text: PropTypes.string,
    showText: PropTypes.bool,
    backgroundVideo: Media && Media.propTypes.video,
    image: PropTypes.shape({
        url:PropTypes.string,
        altText: PropTypes.string
    }),
    curious: CuriousBlock.propTypes,
};

export default HeaderImageBlock;




// WEBPACK FOOTER //
// ./src/components/HeaderImageBlock/HeaderImageBlock.jsx